import { NetworkHelper, RxAxios } from "api";
import { throwError, Observable, iif, of } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';

export namespace TranslateService {

  const props = process.env.TRANSLATE_API_KEYS

  const apiKey = props['key'];
  const apiUrl = props['url'];

  const client = new RxAxios({
    options: {
      baseURL: apiUrl,
    },
  });

  const translateProxy = (original: string) => {
    return client.post<any>(`/services/translate/`, {
      target: NetworkHelper.getLocale().slice(0, 2),
      texts: [original],
    });
  }

  const detectLanguage = (text: string): Observable<string> => {
    const target = NetworkHelper.getLocale().slice(0, 2);
    const throwErrorIfSourceEqualTarget = (source) => {
      return iif(() => source === target, throwError(new Error('target = source')), of(source));
    };

    return client.post<any>(`/detect?key=${apiKey}`, { q: [text] })
      .pipe(
        map(it => it.data.detections[0][0].language), 
        mergeMap(it => throwErrorIfSourceEqualTarget(it)),
      );
  }

  const translate = (text: string, source: string) => {
    return client.post<any>(`/?key=${apiKey}`, {
      target: NetworkHelper.getLocale().slice(0, 2),
      q: [text],
      format: 'text',
      source,
    });
  }

  export const run = (text: string): Observable<string> => {
    return detectLanguage(text).pipe(
      mergeMap(it => translate(text, it)),
      map(it => it.data.translations[0].translatedText),
    );
  }

}
